var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"id":"homework","title":"Homework","back":""}},[_c('timelines',{attrs:{"query":{curriculum_id: _vm.$route.params.id, is_homework: true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }